module.exports = __webpack_public_path__ + "img/img2.19b5c1d5.png";